import { ProductVersionData } from './ProductVersionData'
import { ProductOrToolType } from '@/helpers/EnumHelpers'

export class ProductData {
  public name: string
  public iconFileName: string
  public type: ProductOrToolType
  public panelName: string
  public id: string
  public helpFilePath: string
  public description: string
  public commonFolder: string
  public licensingName: string
  public versions: Array<ProductVersionData>
  public displayUpdateNotification: boolean = false
  public downloadPageUrl: string = ''
  public hidden: boolean = false

  constructor(
    pName: string,
    pIconFileName: string,
    pType: ProductOrToolType,
    pPanelName: string,
    pHelpFilePath: string,
    pDescription: string,
    pCommonFolder: string,
    pLicensingName: string,
    pId: string,
    pVersions: Array<ProductVersionData>,
    pDisplayUpdateNotification: boolean,
    pDownloadPageUrl: string,
    pHidden: boolean
  ) {
    this.name = pName
    this.iconFileName = pIconFileName
    this.type = pType
    this.panelName = pPanelName
    this.helpFilePath = pHelpFilePath
    this.description = pDescription
    this.commonFolder = pCommonFolder
    this.licensingName = pLicensingName
    this.id = pId

    this.versions = pVersions
    this.displayUpdateNotification = pDisplayUpdateNotification
    this.downloadPageUrl = pDownloadPageUrl
    this.hidden = pHidden
  }
}
